import { withTheme } from "@material-ui/core";
import * as React from "react";

import logo from "../../assets/foodforest-logo.svg";
import ContentCard from "../sharedComponents/ContentCard";
import s from "./forgotPasswordInitiate.module.css";

import globalContext from "../../context/globalContext";

class PassLogin extends React.Component {
  static contextType = globalContext;
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <ContentCard>
        <div className={s.container}>
          <div className={s.top}>
            <img src={logo} className={s.logo} alt="logo" />
          </div>
          <div className={s.middle} style={{ marginTop: 0, flex: 0 }}>
            <p>
              Thanks! You can close this window and open your app to log in.
            </p>
            <div className={s.legalLine}>
              <p
                onClick={() => this.props.history.push("/privacy-policy")}
                style={{
                  textDecoration: "underline",
                  textAlign: "center",
                  fontFamily: "Montserrat",
                  marginTop: 20,
                  marginBottom: 0,
                  fontSize: 12,
                  maxWidth: 100,
                  alignSelf: "center"
                }}
              >
                Privacy Policy
              </p>
              <p
                style={{
                  textDecoration: "underline",
                  textAlign: "center",
                  fontFamily: "Montserrat",
                  marginTop: 20,
                  marginBottom: 0,
                  fontSize: 12,
                  maxWidth: 100,
                  alignSelf: "center"
                }}
              >
                |
              </p>
              <p
                onClick={() => this.props.history.push("/terms-of-service")}
                style={{
                  textDecoration: "underline",
                  textAlign: "center",
                  fontFamily: "Montserrat",
                  marginTop: 20,
                  marginBottom: 0,
                  fontSize: 12,
                  maxWidth: 100,
                  alignSelf: "center"
                }}
              >
                Terms of Service
              </p>
            </div>
          </div>
        </div>
        {/* <Snackbar
          anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
          style={{ width: '80%', left: '10%' }}
          open={error ? true : false}
          onClose={() => this.setState({ error: false, labelText: 'email', helperText: '' })}
          ContentProps={{
            'aria-describedby': 'message-id'
          }}
          message={
            <div className={s.snackbarText} id="message-id">
              <CancelIcon
                style={{
                  color: this.props.theme.palette.error.main
                }}
              />
              <div style={{ paddingLeft: 10 }}>{labelText}</div>
            </div>
          }
        /> */}
      </ContentCard>
    );
  }
}

export default withTheme()(PassLogin);
